import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { SubtipoPublicacionesDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class SubtipoPublicacionesService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getSubtipoPublicacionesService(): Observable<BodyListResponse<SubtipoPublicacionesDTO>> {
    return this.http.get<BodyListResponse<SubtipoPublicacionesDTO>>(API_URL + '/api/v1/subtipoPublicaciones/todos');
  }

  guardarSubtipoPublicacionesService(subtipoPublicacionesDTO: SubtipoPublicacionesDTO): Observable<BodyResponse<SubtipoPublicacionesDTO>> {
    return this.http.post<BodyResponse<SubtipoPublicacionesDTO>>(API_URL + '/api/v1/subtipoPublicaciones', subtipoPublicacionesDTO);
  }

  getSubtipoPublicacionesPorCodigoSubtipoPublicacionesService(codigoSubtipoPublicaciones: string): Observable<BodyResponse<SubtipoPublicacionesDTO>> {
    return this.http.get<BodyResponse<SubtipoPublicacionesDTO>>(API_URL + '/api/v1/subtipoPublicaciones/' + codigoSubtipoPublicaciones);
  }
}
